/* ============================================================================ */
/* PATHPAL GOLF: BLOG COMPONENTS
/* pathpal-blog-components.js
/* ============================================================================ */

/* ============================================================================ */
/* FAQ ACCORDION
/* ============================================================================ */

console.log('pathpal-blog-components.js loaded at:', new Date().toISOString());


(function() {
  'use strict';
  
  function initializePathPalFaq() {
    console.log('Attempting to initialize FAQ...');
    
    const articleContent = document.getElementById('pathpal-article-content');
    if (!articleContent) {
      console.log('Article content not found');
      return;
    }
    
    const faqSection = articleContent.querySelector('.faq-section');
    if (!faqSection) {
      console.log('FAQ section not found');
      return;
    }

    const faqItems = faqSection.querySelectorAll('.faq-item');
    console.log('Found ' + faqItems.length + ' FAQ items');

    faqItems.forEach(function(item) {
      const button = item.querySelector('.faq-question');
      const answer = item.querySelector('.faq-answer');
      
      if (!button || !answer) {
        console.log('Missing button or answer in FAQ item');
        return;
      }

      // CHECK IF THIS SPECIFIC BUTTON ALREADY HAS A HANDLER
      if (button.dataset.hasClickHandler === 'true') {
        console.log('Button already has click handler - skipping');
        return;
      }

      // Set initial closed state
      if (!item.classList.contains('active')) {
        answer.style.maxHeight = '0px';
      }

// After you set initial state, add this observer
if (!item.classList.contains('active')) {
  answer.style.maxHeight = '0px';
}

// ADD THIS OBSERVER
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.attributeName === 'class') {
      const hasActive = item.classList.contains('active');
      console.log('FAQ item class changed. Has active?', hasActive, 'Classes:', item.className);
      
      // Log the full stack trace to see what changed it
      console.trace('Class change stack trace');
    }
  });
});
observer.observe(item, { attributes: true, attributeFilter: ['class'] });

 button.addEventListener('click', function(event) {
  console.log('=== FAQ CLICK START ===');
  event.preventDefault();
  event.stopPropagation();
  
  const wasActive = item.classList.contains('active');
  console.log('wasActive captured as:', wasActive);

  // Close all items first
  faqItems.forEach(function(otherItem) {
    otherItem.classList.remove('active');
    const otherAnswer = otherItem.querySelector('.faq-answer');
    if (otherAnswer) {
      otherAnswer.style.maxHeight = '0px';
    }
  });

  // If this item WASN'T active before we closed everything, open it
  if (!wasActive) {
    item.classList.add('active');
    answer.style.maxHeight = answer.scrollHeight + 'px';
    console.log('JUST ADDED active class. Current classes:', item.className);
    
    // Check again after a tiny delay
    setTimeout(function() {
      console.log('After 100ms, classes are now:', item.className);
    }, 100);
    
    setTimeout(function() {
      console.log('After 500ms, classes are now:', item.className);
    }, 500);
  }
  
  console.log('=== FAQ CLICK END ===');
});

      // MARK THIS BUTTON AS HAVING A HANDLER
      button.dataset.hasClickHandler = 'true';
    });

    console.log('PathPal FAQ initialized successfully');
  }

  // Call it when ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePathPalFaq);
  } else {
    initializePathPalFaq();
  }
  
  window.addEventListener('load', initializePathPalFaq);
  
})();

/* ============================================================================ */
/* SCROLL ANIMATIONS
/* ============================================================================ */

(function() {
  'use strict';
  
  function initializeScrollAnimations() {
    console.log('Initializing scroll animations...');
    
    const scrollElements = document.querySelectorAll('.scroll-animate');
    
    if (scrollElements.length === 0) {
      console.log('No scroll-animate elements found');
      return;
    }
    
    console.log('Found ' + scrollElements.length + ' scroll-animate elements');
    
    // Check if element is in viewport
    const elementInView = (el, offset = 100) => {
      const elementTop = el.getBoundingClientRect().top;
      return elementTop <= (window.innerHeight || document.documentElement.clientHeight) - offset;
    };
    
    // Add visible class and set opacity
    const displayScrollElement = (element) => {
      element.style.opacity = '1';
      element.style.transform = 'translateY(0)';
      element.classList.add('animated');
    };
    
    // Check all elements
    const handleScrollAnimation = () => {
      scrollElements.forEach((el) => {
        if (elementInView(el, 100)) {
          displayScrollElement(el);
        }
      });
    };
    
    // Initial check on page load
    handleScrollAnimation();
    
    // Check on scroll with throttle
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScrollAnimation();
          ticking = false;
        });
        ticking = true;
      }
    });
    
    console.log('Scroll animations initialized successfully');
  }
  
  // Initialize after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeScrollAnimations);
  } else {
    initializeScrollAnimations();
  }
  
  window.addEventListener('load', initializeScrollAnimations);
  
})();

/* ============================================================================ */
/* PROGRESS BAR (if you have one)
/* ============================================================================ */

(function() {
  'use strict';
  
  function initializeProgressBar() {
    const progressBar = document.getElementById('progress-bar');
    if (!progressBar) return;
    
    window.addEventListener('scroll', () => {
      const article = document.querySelector('.article-body');
      if (!article) return;
      
      const articleHeight = article.offsetHeight;
      const scrolled = window.scrollY;
      const articleTop = article.offsetTop;
      const progress = ((scrolled - articleTop) / articleHeight) * 100;
      
      progressBar.style.width = Math.min(Math.max(progress, 0), 100) + '%';
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeProgressBar);
  } else {
    initializeProgressBar();
  }
  
})();